import { Action, SubjectRoles } from "@/api-schema-enums";
import { AppAbility } from "@/casl-provider";
import { User } from "@/store/user-store";
import { AbilityBuilder } from "@casl/ability";

export function setCasaviContactWhitelistPermissions(user: User, builder: AbilityBuilder<AppAbility>): void {
  const { can } = builder;

  if (user.roles.includes(SubjectRoles.CasaviAdministrator)) {
    can(Action.Manage, "CasaviContactWhitelist");
  }
}
